export function RightSideImage() {
  return (
    <div className='relative h-full w-full'>
      <img
        src='/cover.png'
        alt='UI Design Showcase'
        className='absolute inset-0 h-full w-full object-cover'
      />
    </div>
  );
}
